import { Component, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, SecurityContext, OnInit, OnDestroy } from "@angular/core";
import { WebShopService } from "../../services/webShop.service";
import { CoreLogService } from "../../services/log.service";
import { Location } from "@angular/common";
import { SnackBarMessageType, VoucherServiceType } from "../../shared/contentTypes";
import { RouterHelperService } from "../../services/routerHelper.service";
import { Router } from "@angular/router";
import { CheckoutComponent } from "../checkout/checkout.component";
import * as _ from "lodash";
import { snackBarMessageKey, SnackBarService } from "../../services/snackBar.service";
import { DomSanitizer } from "@angular/platform-browser";
import { MenuService } from "../menu/menu.service";
import { animate, keyframes, style, transition, trigger } from "@angular/animations";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { InHouseOrderService } from "../../services/inHouseOrder.service";
import { OrderStatus, OrderType, req_Order, MoveToGroupBasketStatus, StartPaymentSelectStatus } from '../../services/IInHouseOrderService';
import { CustomerDataComponent } from "../customerData/customerData.component";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { AddPurchaseOrderDataModel, orderTypes } from "../../shared/models";
import { BasketComponent } from "../basket/basket.component";
import { Subscription } from "rxjs";
import { CheckoutErrorCode } from "../../shared/enums/checkout-error-code.enum";

const BASKET_NAVIGATION = "phWebshop_ShippingCart_Nav_Header";
const CUSTOMER_DATA_NAVIGATION = "phWebshop_OrderData_Nav_Headero";
const CHECKOUT_NAVIGATION = "phWebshop_Payment_Nav_Header";

@Component({
  selector: "ya-webshop",
  templateUrl: "./webshop.component.html",
  styleUrls: ["./webshop.component.scss"],
  providers: [OverlaySpinnerService, MenuService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("shake", [
      transition("true <=> false", animate("1000ms ease-in",
        keyframes([
          style({ transform: "translate3d(-1px, 0, 0)", offset: 0.1 }),
          style({ transform: "translate3d(2px, 0, 0)", offset: 0.2 }),
          style({ transform: "translate3d(-4px, 0, 0)", offset: 0.3 }),
          style({ transform: "translate3d(4px, 0, 0)", offset: 0.4 }),
          style({ transform: "translate3d(-4px, 0, 0)", offset: 0.5 }),
          style({ transform: "translate3d(4px, 0, 0)", offset: 0.6 }),
          style({ transform: "translate3d(-4px, 0, 0)", offset: 0.7 }),
          style({ transform: "translate3d(2px, 0, 0)", offset: 0.8 }),
          style({ transform: "translate3d(-1px, 0, 0)", offset: 0.9 }),
        ]))
      ),
    ]),
  ]

})
export class WebshopComponent implements OnInit, OnDestroy {
  @ViewChild(CheckoutComponent) checkout: CheckoutComponent;
  @ViewChild(CustomerDataComponent) customerData: CustomerDataComponent;
  @ViewChild(BasketComponent) basketdata: BasketComponent;

  public matGroupSelectedIndex: number = 0;
  // used to set ink bar on navigation
  public webshopNavigations;
  public states = {}; // Used to animate Navbar
  public activeLink: string;
  private _inHouseUiDataChangedSub: Subscription;
  public withCheckout: boolean = false;
  public getCustomerData: boolean = false;

  private isSmallView: boolean = false;
  private openCheckoutInitiated = false;

  constructor(private _webShopService: WebShopService
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _routerHelperService: RouterHelperService
    , private _router: Router
    , private _snackBarService: SnackBarService
    , private _location: Location
    , private _domSanitizer: DomSanitizer
    , private _inHouseOrderService: InHouseOrderService
    , _mainnavService: MainnavService) {
    const me = this;
    me.webshopNavigations = [BASKET_NAVIGATION];
    me.activeLink = BASKET_NAVIGATION;
    me.isSmallView = _mainnavService.viewType === ViewType.Small;
  }

  ngOnInit(): void {
    const me = this;
    // Im Haus Bestellungen können beim Start der App in dieser Route ".../webshop" im OnInit noch nicht vorhanden sein und werden daraufhin ermittelt
    me._inHouseUiDataChangedSub = me._inHouseOrderService.ObserveUiDataChanged.subscribe(() => {
      me.RenderCheckout();
    })

    me.RenderCheckout(true);
  }

  ngOnDestroy(): void {
    // Führt Cleanup durch
    const me = this;

    if (me._inHouseUiDataChangedSub)
      me._inHouseUiDataChangedSub.unsubscribe();
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("WebshopComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  /** Aktualisiert den Status, ob Gezahlt wird oder nur bestellt.
   * Achtung siehe auch basket.service.ts
   */
  private RenderCheckout(force: boolean = false): void {
    const me = this;
    me._webShopService.getWebshopSettingsDataModel().then((settings) => {
      // Spätere Zahlung ist bei allen Bestellarten auser InHouse erlaubt
      // Für InHouse kann es auch erzwungen werden, nur nicht für die Gruppenbestellung
      const mandatory_Payment = me._inHouseOrderService.TableData.mandatory_Payment;
      const withCheckout = !(me._webShopService.ordertype.useYASBasket && ((settings.order_inhouse_without_payment && !mandatory_Payment) || me._inHouseOrderService.UiData.isGroup));
      if (force || me.withCheckout !== withCheckout) {
        me.withCheckout = withCheckout;
        if (me.withCheckout) {
          me.getCustomerData = me._webShopService.hasCustomerInputFields;
          if (me.getCustomerData) {
            me.webshopNavigations.push(CUSTOMER_DATA_NAVIGATION);
          }
          me.webshopNavigations.push(CHECKOUT_NAVIGATION);
          me.PushChanges();
        }
        me.basketdata.isSingleTab = !(me.withCheckout && me.getCustomerData);
      }
    });
  }

  /** Basket onContinue (async) */
  public onContinue_basket($event: { to_group_basket: boolean }) {
    const me = this;
    if (me.getCustomerData) {
      me.openCustomerData();
    } else {
      if (me.withCheckout) {
        me.openCheckout(false);
      } else {
        //todo check for inhouse group order
        if ($event.to_group_basket) {
          me._moveUserBasketToGroupBasketInhouse();
        } else {
          me._orderInhouse();
        }
      }
    }
  }

  private async openCustomerData() {
    const me = this;
    me.changeTab(1);
  }

  private _moveUserBasketToGroupBasketInhouse() {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    me._inHouseOrderService.MoveToGroupBasket().then((response) => {
      me._overlaySpinnerService.HideLayoutSpinner();
      if (response.status === MoveToGroupBasketStatus.Okay) {
        me._webShopService.clearItems(); // items from user basket to group basket
        me._inHouseOrderService.openInHauseLandingPage();
      } else {
        me._coreLogService.error("WebshopService._moveUserBasketToGroupBasketInhouse", "MoveToGroupBasket status not Okay", response.status);
        me._snackBarService.ShowErrorMessageFailed(97);
      }
    }).catch((error) => {
      me._overlaySpinnerService.HideLayoutSpinner();
      me._coreLogService.error("WebshopService._moveUserBasketToGroupBasketInhouse", "MoveToGroupBasket catch", error);
      me._snackBarService.ShowErrorMessageFailed(98);
    });
  }

  private _orderInhouse() {
    const me = this;
    const request: req_Order = {
      order_type: OrderType.UserBasket,
    };
    me._overlaySpinnerService.ShowLayoutSpinner();
    me._inHouseOrderService.Order(request).then((response) => {
      me._overlaySpinnerService.HideLayoutSpinner();
      if (response.status === OrderStatus.Okay) {
        me._webShopService.clearItems(); // items from basket to table
        me._router.navigate(["/inHauseOrderConfirm"]);
      } else {
        me._coreLogService.error("WebshopService._orderInhouse", "Order status not Okay", response.status);
        me._snackBarService.ShowErrorMessageFailed(99);
      }
    }).catch((error) => {
      me._overlaySpinnerService.HideLayoutSpinner();
      me._coreLogService.error("WebshopService._orderInhouse", "Order catch", error);
      me._snackBarService.ShowErrorMessageFailed(100);
    });
  }

  /** CustomerData onContinue (async) */
  public onContinue_customerData(useDeliveryAddress: boolean = false) {
    const me = this;
    if (me.withCheckout) {
      me.openCheckout(useDeliveryAddress);
    } else {
      me._orderInhouse();
    }
  }

  /**
   * Initiates the checkout process for the user.
   * Ensures that the flow runs only once at a time, shows a loading spinner,
   * updates the user data, builds the order, runs payment selection if needed,
   * and proceeds to checkout.
   * 
   * @param useDeliveryAddress Whether to use the delivery address for the order.
   */
  private async openCheckout(useDeliveryAddress: boolean = false): Promise<void> {
    const me = this;

    if (me.openCheckoutInitiated) return;

    me.openCheckoutInitiated = true;
    me._overlaySpinnerService.ShowLayoutSpinner();
    try {
      await me._webShopService.onUserChange();
      const order = await me.buildOrder(useDeliveryAddress);
      await this.checkIfToRunPaymentSelection();
      this.proceedCheckout(order);
    } catch (error) {
      const code = typeof error === 'number' ? error : CheckoutErrorCode.Unknown;
      if (code === CheckoutErrorCode.RetailDeliveryCountryUnresolved) {
        me._snackBarService.ShowMessage(snackBarMessageKey.retailDeliveryCountryMissing, SnackBarMessageType.Warning);
        me.onNavigateToBasket();
      } else {
        me._coreLogService.error("WebshopComponent.openCheckout", "catch", error);
        me._snackBarService.ShowErrorMessageFailed(code);
      }
    } finally {
      me._overlaySpinnerService.HideLayoutSpinner();
      me.openCheckoutInitiated = false;
    }
  }

  /**
   * Builds the purchase order model for checkout.
   * Throws an error if the order model could not be created.
   * 
   * @param useDeliveryAddress Whether to use the delivery address in the order.
   * @returns The built order model.
   */
  private async buildOrder(useDeliveryAddress: boolean): Promise<AddPurchaseOrderDataModel> {
    const me = this;
    const order = await me._webShopService.createAddPurchaseOrderDataModel(useDeliveryAddress);
    if (!order) throw CheckoutErrorCode.BuildOrderFailed;

    return order;
  }

  /**
   * Checks if the payment selection step should be run.
   * If yes, attempts to start the payment selection process and throws if it fails.
   */
  private async checkIfToRunPaymentSelection(): Promise<void> {
    const me = this;
    if (!(me._webShopService && me._webShopService.ordertype && me._webShopService.ordertype.useYASBasket)) return;

    const result = await me._inHouseOrderService.StartPaymentSelect();
    if (!(result && result.status === StartPaymentSelectStatus.Okay)) {
      throw CheckoutErrorCode.PaymentStartFailed;
    }
  }

  /**
   * control the tab change in top navigation and page tabs
   * Changes the current active tab in the UI.
   * Also closes the delivery address form if navigating back to earlier steps.
   * 
   * @param index The tab index to switch to.
   */
  private changeTab(index: number): void {
    const me = this;
    if (me.getCustomerData && index <= 1 && me.matGroupSelectedIndex <= 1) {
      me.customerData.toggleBillingInfo(true);
    }
    me.matGroupSelectedIndex = index;
    me.activeLink = me.webshopNavigations[index];
    me.PushChanges();
  }

  public onNavigateToBasket() {
    const me = this;
    if (me.basketdata) {
      me.basketdata.refreshSelectedServiceTime();
    }
    me.changeTab(0); // Navigate to basket tab (index 0)
  }

  /**
   * Proceeds to the checkout step with the given order.
   * Initializes the checkout component with the order and voucher data.
   * Throws if the checkout component is not available.
   * 
   * @param order The purchase order to be processed.
   */
  private proceedCheckout(order: AddPurchaseOrderDataModel): void {
    const me = this;
    if (!me.checkout) throw CheckoutErrorCode.MissingCheckout;

    me.changeTab(me.getCustomerData ? 2 : 1);

    var webvoucher = (me._webShopService && me._webShopService.userWebvoucher) != null
      ? me._webShopService.userWebvoucher
      : null;

    me.checkout.initialize(order, webvoucher);
  }

  /** navigation back by swiping from left to right,
   *  if smallview and tipslider is not sliding */
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView === true && !me.basketdata.tipSlider._isSliding) {
      me.navigateBack();
    }
  }

  public navigateBack() {
    const me = this;
    if (me.checkout && me.checkout.showWebDropIn) {
      me.checkout.toggleWebDropInVisibility(false); // If the WebDropIn is shown, hide it
    } else if (me.getCustomerData && me.activeLink === CUSTOMER_DATA_NAVIGATION && !me.customerData.showBillingInfo) {
      me.customerData.toggleBillingInfo(true);  // Close DeliveryAddress if open
    } else {
      me._navigateToPreviousTab();
    }
  }

  private _navigateToPreviousTab() {
    const me = this;

    if (me.matGroupSelectedIndex > 0) {
      if (me._webShopService.ordertype.useYASBasket) {
        me._inHouseOrderService.AbortPaymentSelect();
      }
      me.changeTab(me.matGroupSelectedIndex - 1);
      return;
    }

    if (!me._webShopService.allowBasketModification) {
      me._navigateToUrlBasket();
      return;
    }

    const chargeWebVoucher = me._webShopService.voucherServiceType === VoucherServiceType.Charge;
    const hasValidItemGroup = me._webShopService.activeItemGroupId && me._webShopService.activeItemGroupId !== -1;

    if (hasValidItemGroup || chargeWebVoucher) {
      me._routerHelperService.setRouteTargetDataByKey("activeItemGroupId", me._webShopService.activeItemGroupId);
      me._location.back();
    } else {
      me._router.navigate(["/menugroup"], { replaceUrl: true });
    }
  }

  private _navigateToUrlBasket(): void {
    const me = this;
    window.open(me._domSanitizer.sanitize(SecurityContext.URL, me._webShopService.returnURLBasket), "_self");
  }

  public canNavigateBack() {
    const me = this;
    return !(!me._webShopService.allowBasketModification && !me._webShopService.returnURLBasket && me.matGroupSelectedIndex === 0);
  }

  public ShakeLabel(stateVar: string) {
    const me = this;
    me.states[stateVar] = !me.states[stateVar];
  }
}
